import gql from "graphql-tag";

export default gql`
  query ($search: String, $page: Int, $pageSize: Int, $userID: String) {
    fonts(search: $search, page: $page, pageSize: $pageSize, userID: $userID) {
      count
      hits {
        id
        family
        variants {
          variant
          file {
            url
          }
        }
        global
      }
    }
  }
`;
